module.exports = {
    // app_url: 'http://deputy-api.2cubes.ru',
    // app_socket_url: 'http://deputy-api.2cubes.ru:3019',
    // app_url: 'http://deputy.local',
    // app_socket_url: 'http://localhost:3019',
	app_url: 'https://api.unihandles.co.uk',
    app_socket_url: 'https://unihandles.co.uk',
    GOOGLE_MAP_API_KEY: 'AIzaSyDyoWZ1tWbWnX6SLdZMNohAz_FN7bGciCI'
};
